import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCUte1cNTzf6mhhTi6mikT-L7eLaeQxcow",
  authDomain: "ruta-n-biorev.firebaseapp.com",
  projectId: "ruta-n-biorev",
  storageBucket: "ruta-n-biorev.firebasestorage.app",
  messagingSenderId: "604938117817",
  appId: "1:604938117817:web:888d2128cb43e4a10eb168",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
